import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative py-6 border-y border-white/5 bg-slatewarm overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-lux italic text-xl sm:text-2xl text-dim/70 px-8">{t}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-brass/50" />
          </span>
        ))}
      </div>
    </div>
  );
};
